import { UnwrapHelper } from '../UnwrapHelper';
export class UnwrapAttributeHelper extends UnwrapHelper {
}

//# sourceMappingURL=UnwrapAttributeHelper.js.map
